export default __webpack_public_path__ + "static/media/incorrect-answer.f80cc821.svg";